import { apiClient } from "@config/apiClient";
import { AINote } from "@app-types/notes.type";
import { CreateNoteRequest } from "@app-types/requests.type";
import { IPagedResponse } from "@interfaces/responses.interface";
import { API_URL } from "@config/constants";

class NoteService {
  private URL = `${API_URL}/notes`;

  async getNoteById(noteId: string): Promise<AINote> {
    return apiClient.get(`${this.URL}/notes/${noteId}/`);
  }

  async getThreadBoundNote(threadId: string): Promise<AINote> {
    return apiClient.get(`${API_URL}/emails/threads/${threadId}/bound-note/`);
  }

  async getThreadBoundNotes(params: URLSearchParams): Promise<IPagedResponse<AINote>> {
    return apiClient.get(`${API_URL}/emails/bound-notes/?${params.toString()}`);
  }

  async getMeetingBoundNote(meetingId: string): Promise<AINote> {
    return apiClient.get(`${API_URL}/meetings/add-in/${meetingId}/bound-note/`);
  }

  async getMeetingBoundNotes(params: URLSearchParams): Promise<IPagedResponse<AINote>> {
    return apiClient.get(`${API_URL}/meetings/bound-notes/?${params.toString()}`);
  }

  async createNote(data: CreateNoteRequest): Promise<AINote> {
    return apiClient.post(`${this.URL}/notes/`, data);
  }

  async updateNote(noteId: string, data: Partial<AINote>): Promise<AINote> {
    return apiClient.patch(`${this.URL}/notes/${noteId}/`, data);
  }
}

const noteService = new NoteService();
export default noteService;
